export default "__VITE_ASSET__e2b56378__"